import { fetchGroupPrices } from "@gn-audio/core/api/pricing/fetch-group-prices";
import { IFromPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import { IEcomSetting } from '@gn-audio/core/api/site-settings/models/ecom-setting';
import { Component, Input, OnInit, Inject } from 'angular-ts-decorators';
import { fetchFamilyOrGroupsAttributes, sortGroupsByPrice } from '../utils';
import { CustomizerApiService } from './customizer-api.service';
import { CustomizerEvents } from '../models/customizer-events';
import { IHeroCustomizerV2Configuration } from './models/hero-customizer-v2.configuration';
import { notifySubscribers } from '../utils/notify-subscribers';

import template from './hero-customizer-v2.component.html';

@Component({
  selector: 'heroCustomizerV2',
  template,
})
export class HeroCustomizerV2Component implements OnInit {
  public static $inject: ReadonlyArray<string> = [];

  @Input('@') public configurationId?: string;

  public configuration?: IHeroCustomizerV2Configuration;
  public groups?: IProductWithAttributes[];
  public selection?: IProductWithAttributes;
  public engravingMessage?: string;

  constructor(
    @Inject('$location') private readonly $location: ng.ILocationService,
    @Inject('$q') private readonly $q: ng.IQService,
    @Inject('customizerApiService') private readonly customizerApiService: CustomizerApiService,
  ) { }

  public ngOnInit() {
    this.customizerApiService
      .getHeroCustomizerV2(this.configurationId)
      .then(this.onConfigurationLoad.bind(this));
  }

  public onSelectionChange(group: IProductWithAttributes) {
    this.selection = group;
    notifySubscribers(CustomizerEvents.SelectionChanged, group);
    this.setSkuInUrl();
  }

  private onConfigurationLoad(configuration: IHeroCustomizerV2Configuration) {
    this.configuration = configuration;
    notifySubscribers(CustomizerEvents.ConfigurationLoaded, this.configuration);
    this.$q.when(fetchFamilyOrGroupsAttributes(this.configuration.familyId, this.configuration.groupIds))
      .then(this.onGroupsLoad.bind(this));
  }

  private onGroupsLoad(groups: IProductWithAttributes[] = []) {
    notifySubscribers(CustomizerEvents.GroupsLoaded, groups);
    if (this.configuration.keepGroupSortOrder && this.configuration.groupIds.length > 0) {
      this.onGroupsProcess(groups);
      return;
    }

    this.$q.when(fetchEcomSetting())
      .then((ecomSetting: IEcomSetting | null) => {
        if (!ecomSetting?.ecomEnabled) {
          this.onGroupsProcess(groups);
        } else {
          this.$q.when(fetchGroupPrices(groups.map((x: IProductWithAttributes) => x.groupId)))
            .then((prices: IFromPrice[] | ISFCCGroupPrice[]) => { this.onGroupsProcess(sortGroupsByPrice(groups, prices)); });
        }
      });
  }

  public onEngravingMessageChange(message: string) {
    this.engravingMessage = message;
  }

  private onGroupsProcess(groups: IProductWithAttributes[] = []) {
    this.groups = groups;
    notifySubscribers(CustomizerEvents.GroupsProcessed, this.groups);
    this.setSelectionOnInit();
  }

  private setSelectionOnInit() {
    const skuFromUrl = this.$location.hash() || '';
    if (skuFromUrl) {
      this.selection = this.groups.filter((x: IProductWithAttributes) => x.sku === skuFromUrl)[0];
    }

    if (!this.selection) {
      this.selection = this.groups[0];
      this.setSkuInUrl();
    }

    notifySubscribers(CustomizerEvents.SelectionChanged, this.selection);
  }

  private setSkuInUrl() {
    this.$location.hash(this.selection.sku);
  }
}
